module.exports = __webpack_public_path__ + "img/2.69154562.jpg";